import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { PACIMPgpWithProvider } from '@core/model';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { GOLD_CARD_AUTH_TYPE_FIELD, GOLD_CARD_AUTH_TYPE_HEADER, GOLD_CARD_FIELD, GOLD_CARD_HEADER } from '@shared/constants/goldcardprovider.constant';

interface ServicingFacilityGeneralInfo {
  parentCompanyName: string;
  npi: string;
  network: string;
  outOfNetwork: boolean;
  isGoldCardProvider: boolean;
  taxId: string;
  cmsNumber: string;
  medicaidNumber: string;
  goldCardAuthType: string;
}

@Component({
    selector: 'servicing-facility-general-info',
    templateUrl: './servicing-facility-general-info.component.html',
    styleUrls: ['./servicing-facility-general-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicingFacilityGeneralInfoComponent implements OnInit, OnChanges {
  @Input() servicingFacility: PACIMPgpWithProvider;
  @Input() tenantName: string;
  @Input() isGoldCardVisible = false;

  generalInfo!: [ServicingFacilityGeneralInfo];
  generalInfoColumns: TableColumn[] = [];
  infoColumns = [
    new TableColumn('Parent Company Name', 'parentCompanyName'),
    new TableColumn('NPI', 'npi'),
    new TableColumn('HP Network', 'network'),
    new TableColumn(`Out of Member's Network`, 'outOfNetwork'),
    new TableColumn(GOLD_CARD_HEADER, GOLD_CARD_FIELD),
    new TableColumn(GOLD_CARD_AUTH_TYPE_HEADER, GOLD_CARD_AUTH_TYPE_FIELD),
    new TableColumn('Tax ID', 'taxId'),
    new TableColumn('CMS Number', 'cmsNumber'),
    new TableColumn('Medicaid Number', 'medicaidNumber')
  ];

  ngOnInit(): void {
    this.generalInfo = [{
      cmsNumber: this.servicingFacility.cmsnumber,
      medicaidNumber: this.servicingFacility.medicaidNumber,
      network: this.getNetwork(),
      npi: this.servicingFacility.npi,
      outOfNetwork: this.servicingFacility.outOfMembersNetwork,
      isGoldCardProvider: this.servicingFacility.isGoldCardProvider,
      parentCompanyName: this.servicingFacility.parentCompany,
      taxId: this.servicingFacility.taxId,
      goldCardAuthType: this.servicingFacility.facilityServiceType
    }];
  }

  ngOnChanges(): void {
    this.generalInfoColumns = this.infoColumns.filter(col => this.isGoldCardVisible || col.field !== GOLD_CARD_FIELD);
    this.generalInfoColumns = this.generalInfoColumns.filter(col => this.isGoldCardVisible && this.servicingFacility.isGoldCardProvider || col.field !== GOLD_CARD_AUTH_TYPE_FIELD);
  }

  private getNetwork(): string {
    const network = this.servicingFacility.participatingNetworks;

    return network || this.tenantName || 'N/A';
  }
}
